// Матрица, где в каждой ячейке содержится sourceId параметра, соответвующий ячейке в матрице
const sourceParametersMap = new Array(24)
  .fill(0)
  .map((_, columnIndex) => new Array(8).fill(0).map((_, rowIndex) => `mC${rowIndex + 1}_SK${columnIndex + 1}`))

const liftPlateContactsMatrixConfig = { sourceParametersMap }

export default liftPlateContactsMatrixConfig
